import { colors, Typography } from '@material-ui/core'
import styled from 'react-emotion/macro'

export const FailureText = styled(Typography)`
  color: ${colors.red['500']} !important;
`
